import { apiClient } from './config'

export const DOCUMENT_TYPES = {
  QUOTE: 'QUOTE',
  CONTRACT: 'CONTRACT',
  INVOICE: 'INVOICE',
}

export const DOCUMENT_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  VIEWED: 'VIEWED',
  SIGNED: 'SIGNED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PAID: 'PAID',
}

export const documentsService = {
  async getDocuments(params = {}) {
    const { role = 'all', type, status, chatId, page = 1, limit = 20 } = params
    const queryParams = new URLSearchParams()
    
    queryParams.append('role', role)
    if (type) queryParams.append('type', type)
    if (status) queryParams.append('status', status)
    if (chatId) queryParams.append('chatId', chatId)
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    
    return apiClient.get(`/documents?${queryParams.toString()}`)
  },

  async getSentDocuments(params = {}) {
    return this.getDocuments({ ...params, role: 'sent' })
  },

  async getReceivedDocuments(params = {}) {
    return this.getDocuments({ ...params, role: 'received' })
  },

  async getDocumentById(id) {
    return apiClient.get(`/documents/${id}`)
  },

  async createDocument(data) {
    return apiClient.post('/documents', data)
  },

  async createQuote(chatId, recipientUserId, title, payload, currency = 'EUR') {
    return this.createDocument({
      type: DOCUMENT_TYPES.QUOTE,
      chatId,
      recipientUserId,
      title,
      currency,
      payload,
    })
  },

  async createContract(chatId, recipientUserId, title, payload, currency = 'EUR') {
    return this.createDocument({
      type: DOCUMENT_TYPES.CONTRACT,
      chatId,
      recipientUserId,
      title,
      currency,
      payload,
    })
  },

  async createInvoice(chatId, recipientUserId, title, payload, currency = 'EUR') {
    return this.createDocument({
      type: DOCUMENT_TYPES.INVOICE,
      chatId,
      recipientUserId,
      title,
      currency,
      payload,
    })
  },

  async uploadDocumentWithFile(data) {
    return apiClient.post('/documents', data)
  },

  async requestSignature(documentId, redirectUrls = {}) {
    return apiClient.post(`/documents/${documentId}/sign-request`, redirectUrls)
  },

  async rejectDocument(documentId, reason) {
    return apiClient.post(`/documents/${documentId}/reject`, { reason })
  },

  async cancelDocument(documentId) {
    return apiClient.post(`/documents/${documentId}/cancel`)
  },

  async markAsPaid(documentId) {
    return apiClient.post(`/documents/${documentId}/mark-paid`)
  },
}
